import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Flex)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
  imagePosition: Maybe<string>;
}>`
  ${({ backgroundColor, imagePosition, theme }) => css`
    flex-direction: ${imagePosition === 'left' ? 'column' : 'column-reverse'};
    background-color: ${backgroundColor || theme.colors.white};
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};

    ${theme.media.md.up} {
      flex-direction: ${imagePosition === 'left' ? 'row' : 'row-reverse'};
    }
  `}
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;

export const Content = styled(Box)<{
  backgroundColor: string;
  backgroundPosition: string;
  textAlignment: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  ${({ backgroundColor, backgroundPosition, textAlignment, theme }) => css`
    text-align: ${textAlignment};
    padding: ${theme.spacing(2, 0, 2, 0)};
    background-color: ${backgroundColor ?? theme.colors.white};

    ${theme.media.md.up} {
      width: ${backgroundPosition};
      padding: ${theme.spacing(5)} ${theme.spacing(1)};
    }

    ${theme.media.md.down} {
      margin-top: -2px;
    }
  `}
`;
export const ImageWrapper = styled(Box)<{
  backgroundPosition: string;
  mediaAnimationEffect?: string | null;
}>`
  position: relative;
  overflow: hidden;
  ${({ mediaAnimationEffect }) => css`
    ${mediaAnimationEffect &&
    css`
      &:hover {
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}
  `};
  ${({ backgroundPosition, theme }) => css`
    ${theme.media.md.up} {
      width: calc(100% - ${backgroundPosition});
    }
  `};
`;
export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  position: absolute;

  ${({ $backgroundAlignment, theme }) => css`
    ${theme.media.md.down} {
      position: unset;
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;
